import { render } from "./EventFormComponent.vue?vue&type=template&id=116b9371&scoped=true"
import script from "./EventFormComponent.vue?vue&type=script&lang=js"
export * from "./EventFormComponent.vue?vue&type=script&lang=js"

import "./EventFormComponent.vue?vue&type=style&index=0&id=116b9371&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116b9371"]])

export default __exports__